export const USER_ROLES = {
  CLIENT: 1,
  ADMIN: 9,
  CLIENT_COMPANY_ADMIN: 10
}

export default {
  data () {
    return {
      sideNavType: 'Merchant',
      offset: 0
    }
  },
  mounted () {
    this.$shipBobStore.dispatch('detectBrowser')
  },
  computed: {
    showSplashScreen () {
      return this.$shipBobStore.getters.showSplashScreen
    },
    adminMargin () {
      const marginTop = `${this.offset}px`
      return { marginTop }
    },
    user () {
      return this.$shipBobStore.getters['user/getUser']
    },
    isAdmin () {
      return this.user.isAdmin
    },
    isMerchantAdmin () {
      return this.user?.impersonatedRoleId === USER_ROLES.CLIENT || this.user?.impersonatedRoleId === USER_ROLES.CLIENT_COMPANY_ADMIN
    }
  }
}
